import { Skeleton } from '@/components'

export const TemperatureSkeleton = () => (
  <Skeleton animation="wave" variant="text" width={25} height={18} />
)

export const TemperatureBarSkeleton = () => (
  <Skeleton animation="wave" variant="text" width={137} height={18} />
)

export const CostSheetSkeleton = () => (
  <Skeleton animation="wave" variant="text" width={34} height={26} />
)
